import { render } from "./psp-sorting-page.vue?vue&type=template&id=7a4cab7b"
import script from "./psp-sorting-page.ts?vue&type=script&lang=js"
export * from "./psp-sorting-page.ts?vue&type=script&lang=js"

import "./psp-sorting-page.scss?vue&type=style&index=0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__